import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/pages/admin/AdminLayout";
import Leads from "@/pages/admin/Leads";
import PortfolioManager from "@/pages/admin/PortfolioManager";
import Tracker from "@/pages/admin/Tracker";
import TwentyI from "@/pages/admin/TwentyI";
import Clients from "@/pages/admin/Clients";
import Projects from "@/pages/admin/Projects";
import Packages from "@/pages/admin/Packages";
import Payments from "@/pages/admin/Payments";
import StudioHome from "@/pages/admin/StudioHome";
import ChatWorkspace from "@/pages/admin/ChatWorkspace";
import StudioPricing from "@/pages/admin/StudioPricing";
import PortalPayments from "@/pages/portal/PortalPayments";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";
import PortalLayout from "@/pages/portal/PortalLayout";
import PortalProjects from "@/pages/portal/PortalProjects";
import PortalHosting from "@/pages/portal/PortalHosting";
import ProjectDetail from "@/components/project/ProjectDetail";
import InviteAccept from "@/pages/InviteAccept";
import AccessRestricted from "@/pages/AccessRestricted";
import PublishedSite from "@/pages/PublishedSite";
import AppReset from "@/pages/AppReset";
import AppCancelBooking from "@/pages/AppCancelBooking";
import PortalApps, { AdminAppManager, PortalAppDetail } from "@/pages/portal/PortalApps";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/sites/:slug" element={<PublishedSite />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/access-restricted" element={<AccessRestricted />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/leads" replace />} />
        <Route path="leads" element={<Leads />} />
        <Route path="clients" element={<Clients />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail admin />} />
        <Route path="portfolio" element={<PortfolioManager />} />
        <Route path="packages" element={<Packages />} />
        <Route path="payments" element={<Payments />} />
        <Route path="studio" element={<StudioHome />} />
        <Route path="studio/:id" element={<ChatWorkspace />} />
        <Route path="settings/studio-pricing" element={<StudioPricing />} />
        <Route path="apps/:appId" element={<AdminAppManager />} />
        <Route path="tracker" element={<Tracker />} />
        <Route path="settings/20i" element={<TwentyI />} />
      </Route>
      <Route path="/portal" element={<PortalLayout />}>
        <Route index element={<PortalProjects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="payments" element={<PortalPayments />} />
        <Route path="apps" element={<PortalApps />} />
        <Route path="apps/:appId" element={<PortalAppDetail />} />
        <Route path="hosting" element={<PortalHosting />} />
      </Route>
      <Route path="/apps/:appId/reset" element={<AppReset />} />
      <Route path="/apps/:appId/cancel-booking" element={<AppCancelBooking />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
